var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4495 17.768C19.9073 16.4703 18.3422 15.6843 16.8189 16.98L15.9093 17.7631C15.2438 18.3315 14.0064 20.9876 9.22232 15.5735C4.43923 10.1663 7.28557 9.32434 7.95208 8.76078L8.86665 7.97669C10.382 6.67805 9.81012 5.04323 8.71721 3.36038L8.05768 2.34107C6.95979 0.662142 5.76427 -0.44048 4.24496 0.856203L3.42404 1.56188C2.75255 2.04311 0.875581 3.60737 0.420286 6.57906C-0.127662 10.1447 1.60086 14.2278 5.56103 18.7079C9.51622 23.1899 13.3887 25.4412 17.057 25.402C20.1056 25.3697 21.9467 23.7604 22.5225 23.1752L23.3464 22.4686C24.8617 21.1729 23.9203 19.8536 22.3771 18.553L21.4495 17.768Z",
    fill: "#8ABEAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIco);
export default __webpack_public_path__ + "static/media/phone-ico.943f687c3d8f5c9f4b35f19d247a6e00.svg";
export { ForwardRef as ReactComponent };